import React from "react";
import { useParams } from "react-router-dom";
import "./Game.css";

const games = [
  {
    id: "shooting-gallery",
    title: "Shooting Gallery",
    description: "Hit the moving targets to score!",
    genre: "Arcade",
    embedUrl: "https://armorgames.com/embed/14825",
  },
  {
    id: "jump-boy",
    title: "Jump Boy",
    description: "Jump over obstacles in this endless runner.",
    genre: "Adventure",
    embedUrl: "https://v6p9d9t4.ssl.hwcdn.net/html/4808083/index.html",
  },
  {
    id: "zombie-survival",
    title: "Zombie Survival",
    description: "Survive as long as you can against the undead.",
    genre: "Action",
    embedUrl: "https://v6p9d9t4.ssl.hwcdn.net/html/6899976/index.html",
  },
  {
    id: "mini-chess",
    title: "Mini Chess",
    description: "Challenge yourself in a quick chess game.",
    genre: "Strategy",
    embedUrl: "https://www.chess.com/embed/quick-game",
  },
  {
    id: "word-scramble",
    title: "Word Scramble",
    description: "Unscramble letters before time runs out.",
    genre: "Educational",
    embedUrl: "https://v6p9d9t4.ssl.hwcdn.net/html/5141752/index.html",
  },
  {
    id: "flappy-dragon",
    title: "Flappy Dragon",
    description: "Help the dragon fly through obstacles.",
    genre: "Casual",
    embedUrl: "https://v6p9d9t4.ssl.hwcdn.net/html/5218093/index.html",
  },
  {
    id: "match-cards",
    title: "Memory Match",
    description: "Find the matching card pairs.",
    genre: "Puzzle",
    embedUrl: "https://html5.gamedistribution.com/8abf926fef584b83962f28b7efbbfcd0/",
  },
  {
    id: "funny-puppy-care",
    title: "Funny Puppy Care",
    description: "Wash and care for your adorable puppy.",
    genre: "Animal Care",
    embedUrl: "https://html5.gamedistribution.com/fc10756e0c5b4fc2b21f9a246271b5fe/",
  },
  {
    id: "princess-makeup-salon",
    title: "Princess Makeup Salon",
    description: "Give your princess a makeover!",
    genre: "Makeup",
    embedUrl: "https://html5.gamedistribution.com/eee28c8ec9db4c8bb5784a5e95de7a5b/",
  },
  {
    id: "cat-hair-salon",
    title: "Cat Hair Salon",
    description: "Style and pamper your furry friend.",
    genre: "Pet Care",
    embedUrl: "https://html5.gamedistribution.com/67f9f5fa26cf484e99fc624b20455b3f/",
  },
  {
    id: "cute-unicorn-care",
    title: "Cute Unicorn Care",
    description: "Dress up and care for your unicorn!",
    genre: "Fantasy",
    embedUrl: "https://html5.gamedistribution.com/7270e7c1ce2f4fc4bd54b29d38be7f6e/",
  },
  {
    id: "popsy-princess",
    title: "Popsy Princess: Delicious Fashion",
    description: "Dress up your princesses in yummy outfits.",
    genre: "Dress Up",
    embedUrl: "https://html5.gamedistribution.com/ff4ae218a5df4d6e96a48a8d24c9615a/",
  },
  {
    id: "fruit-blast",
    title: "Fruit Blast",
    description: "Connect the fruits for points!",
    genre: "Arcade",
    embedUrl: "https://html5.gamedistribution.com/f92b0a536f204dc79f3e9ee4a80b3f6e/",
  },
  {
    id: "space-invaders",
    title: "Space Invaders Reloaded",
    description: "Defend Earth from alien attackers.",
    genre: "Classic",
    embedUrl: "https://v6p9d9t4.ssl.hwcdn.net/html/7070389/index.html",
  },
  {
    id: "sudoku-lite",
    title: "Sudoku Lite",
    description: "Play an easy and fun sudoku puzzle.",
    genre: "Puzzle",
    embedUrl: "https://html5.gamedistribution.com/949e8373b0a841b2b3843d6a4c879be5/",
  },
];

const Game = () => {
  const { id } = useParams();
  const game = games.find((g) => g.id === id);

  if (!game) {
    return <div className="game-detail"><h2>Game not found</h2></div>;
  }

  return (
    <div className="game-detail">
      <h1>{game.title}</h1>
      <p>{game.description}</p>
      <p><strong>Genre:</strong> {game.genre}</p>

      <img
        src="https://cdn-icons-png.flaticon.com/512/3068/3068384.png"
        alt="Controller preview"
        style={{ width: "400px", borderRadius: "16px", margin: "20px 0" }}
      />

      <a
        href={game.embedUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn start-btn"
      >
        🚀 Start Game in New Tab
      </a>
    </div>
  );
};

export default Game;